var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-modal",
        {
          attrs: {
            title:
              _vm.fileType === "image"
                ? _vm.language["system.file.upload"]
                : _vm.language["system.file.upload"],
            width: _vm.width,
            visible: _vm.visible,
            cancelText: _vm.language["common.cancel"]
          },
          on: { ok: _vm.ok, cancel: _vm.close }
        },
        [
          _c("L-upload", {
            attrs: {
              "file-type": _vm.fileType,
              uploadSource: _vm.uploadSource,
              buttonVisible: !_vm.disabled,
              disabled: _vm.disabled,
              multiple: _vm.multiple
            },
            on: { change: _vm.handleChange },
            model: {
              value: _vm.fileList,
              callback: function($$v) {
                _vm.fileList = $$v
              },
              expression: "fileList"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }